(ns dre.components.widget.db)

; Widget option required in both events and views of widgets can be defined here.
(def widget-options 
  [{:id :top-terms
    :export-counts [{:id :128}
                    {:id :256}
                    {:id :500}]}
   {:id :authors
    :export-counts [{:id :25}
                    {:id :50}
                    {:id :100}]}])

(defn get-widget-options-by-id
  "Get widget option by corresponding widget id"
  [widget-id]
  (->> widget-options
       (filter #(= widget-id (:id %)))
       first))